import React from 'react';
import { SEO } from '../components/SEO';
import SectionHeader from '../components/SectionHeader';

export const Industries = () => {
  const industries = [
    {
      title: 'Pharmaceuticals',
      description: 'From formulation development regulatory support to FDA / CDSCO submissions & approval, we support manufacturers across all dosage forms - oral solids, liquids, parenterals, ophthalmic, topical, and inhalation products. Whether you are a startup seeking your first drug approval or a multinational managing a complex global portfolio, Pegasus delivers regulatory expertise at every scale.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/a950zwik_Pharmceuticals%20.jpeg',
    },
    {
      title: 'Medical Devices & Diagnostics',
      description: 'With the Medical Devices Rules 2017 fully in effect, device manufacturers and importers require specialized regulatory support for classification, registration, technical documentation, and post-market compliance. Pegasus provides end-to-end CDSCO medical device registration support and other submission services.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/wmfadhoq_Medical%20devices%20.jpeg',
    },
    {
      title: 'Cosmetics & Personal Care',
      description: 'India\'s cosmetics regulatory environment - governed by CDSCO under the Drugs and Cosmetics Act - demands precise import licensing, ingredient compliance, and labeling accuracy. We support domestic and international brands with complete regulatory management for skin care, hair care, color cosmetics, and personal hygiene products.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/c0szh9u4_Cosmetics%20%26%20personal%20care.jpg',
    },
    {
      title: 'Nutraceuticals & Dietary Supplements',
      description: 'The nutraceutical space sits at the intersection of food, pharma, and wellness - making regulatory classification critical. We help nutraceutical brands navigate FSSAI regulations, health claim compliance, and labeling requirements.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/4ugouk6i_Nutraceuticals%20%26%20Dietary%20Supplements%20.jpg',
    },
    {
      title: 'Food & Functional Foods',
      description: 'From FSSAI license acquisition to novel food ingredient approvals, Pegasus supports food manufacturers, importers, and exporters with complete food regulatory compliance - across packaged foods, beverages, organic products, and functional foods.',
      image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
    {
      title: 'Ayurveda & Herbal Products',
      description: 'Ayurvedic and herbal product manufacturers require regulatory navigation across AYUSH licensing, Ayurvedic proprietary medicine registration, and labeling compliance. Our consultants understand both the scientific and traditional medicine regulatory dimensions.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/a79u44o7_Ayurveda%20%26%20Herbal%20Products.webp',
    },
    {
      title: 'Contract Research & Manufacturing Organizations (CRO/CMO)',
      description: 'CROs conducting BA/BE studies and clinical trials require reference drug procurement, regulatory documentation, and GMP compliance support. CMOs require regulatory-ready facility design, compliance consulting, and licensing support. Pegasus serves both segments with integrated, expert solutions.',
      image: 'https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/h04yebsu_Contract%20Research%20%26%20Manufacturing%20Organizations%20%28CRO%3ACMO%29.webp',
    },
  ];

  return (
    <div className="pt-[72px]">
      <SEO page="industries" />
      {/* Hero */}
      <section
        className="relative py-24"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/ccwbhxmk_04%20Industry%20we%20Serve%20Home%20page%20photo%20-%20Pharma-Companies-in-Chhattisgarh-1170x684.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, #1570EF 0%, #1570EFee 35%, #1570EFaa 55%, transparent 75%)' }} />
        <div className="relative z-10 max-w-[1280px] mx-auto px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white max-w-2xl" >Industries We Serve</h1>
          <p className="text-xl max-w-2xl text-white/90" >
            Deep-Domain Regulatory Expertise Across Life Sciences & Consumer Health
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="py-16 bg-white">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
          <p className="text-base sm:text-lg text-center max-w-4xl mx-auto" style={{ color: '#1E293B' }}>
            Pegasus Clinicare brings specialized, sector-specific regulatory knowledge to every engagement. Our consultants understand not just the regulatory frameworks, but the unique operational, scientific, and commercial challenges of each industry we serve.
          </p>
        </div>
      </section>

      {/* Industries */}
      <section className="py-24" style={{ backgroundColor: '#EFF6FF' }}>
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
          <div className="space-y-16">
            {industries.map((industry, index) => (
              <div
                key={index}
                data-testid={`industry-${index}`}
                className={`grid md:grid-cols-2 gap-8 items-center ${
                  index % 2 === 1 ? 'md:flex-row-reverse' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                  <h2 className="text-3xl font-bold mb-4" style={{ color: '#1B3A6B' }}>
                    {industry.title}
                  </h2>
                  <p className="text-base" style={{ color: '#1E293B' }}>
                    {industry.description}
                  </p>
                </div>
                <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                  <img
                    src={industry.image}
                    alt={industry.title}
                    className="rounded-2xl shadow-lg w-full object-cover"
                    style={{ height: '300px' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
